export default __webpack_public_path__ + "static/media/1915.7979c31e.png";